// src/utils/useScrollReveal.js
// Hook liviano de "scroll reveal": agrega la clase `is-visible` a los elementos
// que matcheen `selector` dentro de `containerRef` cuando entran en el viewport,
// usando IntersectionObserver (soporte amplio y confiable en todos los navegadores
// modernos). No hace nada si el usuario prefiere movimiento reducido — en ese caso
// el CSS ya deja los elementos visibles por defecto (la regla `opacity:0` solo
// existe dentro de `@media (prefers-reduced-motion: no-preference)`).
import { useEffect } from 'react';

export default function useScrollReveal(containerRef, selector = '.scroll-reveal', deps = []) {
  useEffect(() => {
    const container = containerRef.current;
    if (!container) return undefined;

    const reduceMotion =
      typeof window !== 'undefined' &&
      window.matchMedia &&
      window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (reduceMotion) return undefined;

    const items = container.querySelectorAll(selector);
    if (!items.length) return undefined;

    if (typeof IntersectionObserver === 'undefined') {
      items.forEach((el) => el.classList.add('is-visible'));
      return undefined;
    }

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.15, rootMargin: '0px 0px -40px 0px' }
    );

    items.forEach((el) => observer.observe(el));

    return () => observer.disconnect();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, deps);
}
